module.exports = __webpack_public_path__ + "static/0df313aa-b093-4d0b-a78c-50dcffd00914-926f2a05b11bd4c4c530944058ea0887.jpg";